import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface ICreateParentalLockUseCase {
    execute(apiKey: string, identityToken: string, request: any): Promise<any>;
}

export class CreateParentalLockUseCase implements ICreateParentalLockUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, identityToken: string, request: any): Promise<any> {
        const result = await this.profileRepository.createParentalLock(apiKey, identityToken, request);
        return result.data;
    }
}
